module.exports = __webpack_public_path__ + "img/94_7.e406249d.png";